import * as React from 'react';
import { IOutput, IMoveHandler, IdHelper, EOutputScope,ModalHelper} from '../../helpers';
import { Button, ButtonType, TextField, Dropdown, IDropdownOption, Checkbox } from 'office-ui-fabric-react';

interface IProps {
    outputs: IOutput[];
    overIndex: number;
    moveHandler: IMoveHandler;
    types: IDropdownOption[];
    updateOutputs: (outputs: IOutput[]) => void;
}

export class LoopOutputs extends React.Component<IProps, any> {

    componentDidMount(){
        ModalHelper.scrollToBottom();     
    }
    
    updateOutputName = (name: string, outputId: string) => {
        
        let { outputs, updateOutputs } = this.props;

        let output = outputs.filter(o => o.Id === outputId)[0];

        if(output) {
            output.Name = name;
            updateOutputs(outputs);
        }
    }

    updateLogicalName = (logicalName: string, outputId: string) => {
        
        let { outputs, updateOutputs } = this.props;

        let output = outputs.filter(o => o.Id === outputId)[0];

        if(output) {            
            // Logical name cannot contain spaces. replace with "_";
            logicalName = logicalName.replace(/ /ig, "_");
            // Logical name must only consist of lower case letters, or numbers - toLower()
            logicalName = logicalName.toLowerCase();
            output.LogicalName = logicalName;
            updateOutputs(outputs);
        }
    }

    updateOutputType = (type: number, outputId: string) => {

        let { outputs, updateOutputs } = this.props;

        let output = outputs.filter(o => o.Id === outputId)[0];

        if(output) {
            output.Type = type;
            updateOutputs(outputs);
        }

    }

    removeOutput = (outputId: string) => {

        let { outputs, updateOutputs } = this.props;

        outputs = outputs.filter(o => o.Id !== outputId);

        updateOutputs(outputs);

    }

    addOutput = () => {
        
        let { outputs, types, updateOutputs } = this.props;

        let id: string = IdHelper.newGuid();

        outputs.push({
             Name: "",
             Id: id, 
             Type: +types[0].key, 
             IsRequiredGlobalOutput: false,
             DisablePrepopulatedValue: false, 
             OutputScope: EOutputScope.Loop,
             IsHidden:false
        });

        updateOutputs(outputs);

        ModalHelper.scrollToBottom();
    }

    updateOutputIsMultiple = (outputId: string, isChecked: boolean) => {
        
        let { outputs, updateOutputs } = this.props;

        let output = outputs.filter(o => o.Id === outputId)[0];

        output.IsMultiple = isChecked;

        updateOutputs(outputs);
        
    }

    outputHtml = (output: IOutput, i: number): JSX.Element => {

        let { overIndex, moveHandler, types } = this.props;
        let { Id } = output;

        let isLoopOutput:boolean = output.OutputScope == EOutputScope.Loop;
        return <div key={ Id }
            className={ "option global-output loop-output clearfix " + (overIndex === i ? 'drag-over' : '') }
            onDrop={ (e) => moveHandler.drop(e, i) }
            onDragOver={ (e) => moveHandler.allowDrop(e, i) }>
        
            <Button buttonType={ ButtonType.icon } icon="Move"
                title="Move output"
                className="option-move"
                draggable={ true }
                onDragStart={ (e) => moveHandler.drag(e, i) }
                onDragEnd={ (e) => moveHandler.drop(e, null) }
                tabIndex={-1} />

            <TextField className='output-name' label="Name" value={ output.Name } onChanged={ (val) => this.updateOutputName(val, Id) } required={ true } autoComplete="new-output-name"/>
            <TextField  disabled={!isLoopOutput} className='output-logicalname' label="Logical Name" value={ output.LogicalName } onChanged={ (val) => this.updateLogicalName(val, Id)} required={ true } />
            <div className="output-type">
                <Dropdown disabled={!isLoopOutput} options={ types } label={ 'Type' } selectedKey={ output.Type } onChanged={ (val) => this.updateOutputType(+val.key, Id) }/>
            </div>

            <div className="output-is-array">
                <Dropdown disabled={!isLoopOutput}  options={ [{ key: 'No', text: 'No' }, { key: 'Yes', text: 'Yes' }] } label={ 'Is List?' } selectedKey={ output.IsMultiple ? 'Yes' : 'No' } 
                    onChanged={ (val) => this.updateOutputIsMultiple(output.Id, val.text === 'Yes') }/>
            </div>
            {isLoopOutput && <Button buttonType={ ButtonType.icon } icon="Delete" onClick={ () => this.removeOutput(Id) } title="Delete output"/>}

        </div>;

    }

    render() {

        let { outputs } = this.props;
        let filteredOutputs = outputs.filter((value)=>!value.IsHidden);
        return <div>    
            {filteredOutputs.map(this.outputHtml)}
            <Button icon="Add" onClick={ () => this.addOutput() } buttonType={ ButtonType.normal } label="Add output"/>
        </div>;

    }

}


// WEBPACK FOOTER //
// ./source/ts/components/loop/loop-outputs.tsx